
import { useSupabaseClient } from '@/hooks/useSupabaseClient';
import { Procurement } from '@/types/procurement';

export const fetchPendingProcurements = async (supabase: ReturnType<typeof useSupabaseClient>, analysedIds: string[]) => {
  const query = supabase
    .from('procurements')
    .select('*')
    .eq('status', 'Ny');
    
  // If we have analysed IDs, filter them out
  if (analysedIds.length > 0) {
    query.not('id', 'in', `(${analysedIds.join(',')})`);
  }
  
  const { data, error } = await query;
  
  if (error) throw error;
  
  return data as Procurement[];
};

export const updateProcurementStatus = async (
  supabase: ReturnType<typeof useSupabaseClient>, 
  procurementId: string, 
  status: string
) => {
  const { error } = await supabase
    .from('procurements')
    .update({ status })
    .eq('id', procurementId);
    
  if (error) throw error;
};
